module.exports = __webpack_public_path__ + "static/media/m120-41.20032b00.png";